<template>
  <v-navigation-drawer
    app
    clipped
    v-model="DRAWER_STATE"
    :width="sidebarWidth"
    :temporary="!$vuetify.breakpoint.xsOnly"
  >

    <v-list>
      <template v-for="(item, i) in checkRolesAndMain(items)">
        <!-- Header for section -->
        <v-row
          v-if="item.heading"
          :key="item.heading"
          align="center"
        >
          <v-col cols="6">
            <span
              style="padding-left: 32px"
              class="text-body-1 subheader"
              :class="(item.heading && DRAWER_STATE) ? 'show ' : 'hide'"
            >
              {{ item.heading }}
            </span>
          </v-col>
          <v-col
            cols="6"
            class="text-center"
          >
          </v-col>
        </v-row>

        <!-- Divider -->
        <v-divider
          v-else-if="item.divider"
          :key="i"
          dark
          class="my-4"
        />

        <!-- If one item has child items -->
        <v-list-group
          color="primary"
          v-else-if="item.icon === 'menu_book'"
          :key="item.text"
          v-model="item.model"
        >
          <template v-slot:prependIcon>
            <v-icon size="24" class="mr-0" color="greyTint"> {{ item.icon }}</v-icon>
          </template>
          <template v-slot:activator>
            <v-list-item-content>
              <v-badge v-if="item.badge" content="New" color="secondary">
              </v-badge>
              <v-list-item-title>
                {{ $t('display/navbar:links.logs') }}
              </v-list-item-title>
            </v-list-item-content>
          </template>

          <v-list-item
            v-for="(child, i) in item.children"
            :key="i"
            :to="child.route"
            link
            class="pl-12"
            @click="child.action ? child.action() : null"
          >
            <v-list-item-action class="mr-2" v-if="child.icon">
              <v-icon class="greyTint--text">{{ child.icon }}</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>
                {{ $t('display/navbar:logs.' + child.text) }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>

        <v-list-group
          color="primary"
          v-else-if="item.icon === 'show_chart'"
          :key="item.text"
          v-model="item.model"
        >
          <template v-slot:prependIcon>
            <v-icon size="24" class="mr-0" color="greyTint"> {{ item.icon }}</v-icon>
          </template>
          <template v-slot:activator>
            <v-list-item-content>
              <v-badge v-if="item.badge" content="New" color="secondary">
              </v-badge>
              <v-list-item-title>
                {{ $t('display/navbar:links.statistics') }}
              </v-list-item-title>
            </v-list-item-content>
          </template>

          <v-list-item
            v-for="(child, i) in item.children"
            :key="i"
            :to="child.route"
            link
            class="pl-12"
            @click="child.action ? child.action() : null"
          >
            <v-list-item-action class="mr-2" v-if="child.icon">
              <v-icon class="greyTint--text">{{ child.icon }}</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>
                {{ $t('display/navbar:statistic.'  + child.text) }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>

        <!-- Single item -->
        <v-list-item
          color="primary"
          v-else
          :key="item.text"
          :to="item.route === '#' ? '' : item.route"
          @click="item.action ? item.action() : null"
          link
        >
          <v-list-item-action class="mr-6">
            <v-icon
              :size="item.size ? item.size : 24"
              :color="item.color ? item.color : 'greyTint'"
            >{{ item.icon }}
            </v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title
              link
            >
              {{ $t('display/navbar:links.' + item.text) }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </template>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import {Role} from "../../../core/data/roles";
import {mapActions, mapState} from 'vuex';
import store from '@/store';

const URL_PREFIX = '/' + store.state.manager.displayModuleUrl;

export default {
  name: "DisplaySidebar",
  props: {
    source: String,
  },
  data() {
    return {
      items: [
        {text: 'advert', icon: 'featured_video', route: URL_PREFIX + '/advert', main: false, roles: [Role.Admin, Role.Operator, Role.Manager, Role.Worker]},
        {text: 'elevator', icon:'elevator', route: URL_PREFIX + '/elevator', main: false, roles: [Role.Admin, Role.Operator, Role.Manager, Role.Worker]},
        {text: 'offer', icon: 'local_offer', route: URL_PREFIX + '/offer', main: false, roles: [Role.Admin, Role.Master]},
        {text: 'certificates', icon: 'verified_user', route: URL_PREFIX + '/certificate', main: false, roles: [Role.Admin]},
        {text: 'editor', icon: 'format_shapes', route: URL_PREFIX + '/editor', main: false, roles: [Role.Admin]},
        {text: 'pdfs', icon: 'picture_as_pdf', route: URL_PREFIX + '/pdfs', main: false, roles: [Role.Admin, Role.Operator, Role.Manager, Role.Worker]},
        {text: 'emergencies', icon: 'emergency', route: URL_PREFIX + '/emergency', main: false, roles: [Role.Admin, Role.Operator, Role.Manager, Role.Worker]},
        {divider: true, roles: [Role.Admin]},
        {
          icon: 'menu_book', roles: [Role.Admin], model: false,
          children: [
            { text: 'advert', route: URL_PREFIX + '/logs/advert', main: false },
            { text: 'alive', route: URL_PREFIX + '/logs/alive', main: false },
            { text: 'bootLog', route: URL_PREFIX + '/logs/bootlog', main: false },
            { text: 'download', route: URL_PREFIX + '/logs/download', main: false },
            { text: 'elevator-day', route: URL_PREFIX + '/logs/elevator-day', main: false },
            { text: 'elevator-week', route: URL_PREFIX + '/logs/elevator-week', main: false },
            { text: 'elevator-month', route: URL_PREFIX + '/logs/elevator-month', main: false },
            { text: 'emails', route: URL_PREFIX + '/logs/email', main: false },
            { text: 'log-file', route: URL_PREFIX + '/logs/logfile', main: false },
            { text: 'offline', route: URL_PREFIX + '/logs/offline', main: false },
            { text: 'ride', route: URL_PREFIX + '/logs/ride', main: false },
            { text: 'schedule', route: URL_PREFIX + '/logs/schedule', main: false },
            { text: 'update', route: URL_PREFIX + '/logs/update', main: false }
          ]
        },
        {
          icon: 'show_chart', roles: [Role.Admin], model: false,
          children: [
            { text: 'elevator', route: URL_PREFIX + '/statistic/elevator', main: false },
            { text: 'advert', route: URL_PREFIX + '/statistic/advert', main: false },
            { text: 'workload', route: URL_PREFIX + '/statistic/workload', main: false },
            { text: 'budget', route: URL_PREFIX + '/statistic/budget', main: false }
          ]
        }
      ],
      sidebarWidth: 240,
      sidebarMinWidth: 96,
      dialog: false
    }
  },
  computed: {
    currentUser() {
      return this.$store.state.auth.user;
    },
    isMain() {
      if (this.currentUser) {
        return this.currentUser.main;
      }
      return false;
    },
    ...mapState('display/layout', {
      drawer: state => state.drawer
    }),
    DRAWER_STATE: {
      get() {
        return this.drawer
      },
      set(newValue) {
        if (newValue === this.drawer) return;
        this.TOGGLE_DRAWER();
      }
    }
  },
  methods: {
    ...mapActions(
      'display/layout', ['TOGGLE_DRAWER']
    ),
    checkRolesAndMain: function (links) {
      var self = this;
      return links.filter(function (link) {
        return (!link.main || (link.main && self.isMain))
          && self.hasRole(link.roles);
      })
    },
    hasRole(roles) {
      if (this.currentUser && this.currentUser.roles) {
        for (let i = 0; i < roles.length; i++) {
          if (this.currentUser.roles.includes(roles[i])) {
            return true;
          }
        }
      }
      return false;
    }
  }
}
</script>

<style src="@/modules/core/components/Sidebar/Sidebar.scss" lang="scss"/>
